import MembershipExtensionCreationComponent from "../MembershipExtensionCreationComponent";

const MembershipExtensionCreationPage = () => {
  return (
    <>
      <div className="p-3 pt-0 bg-white w-full">
        <div className="p-3 shadow-md py-3 rounded-lg sticky top-16 bg-white z-30">
          <p className="text-base font-semibold">Membership Extension Setup</p>
        </div>
        <div>
          <MembershipExtensionCreationComponent />
        </div>
      </div>
    </>
  );
};

export default MembershipExtensionCreationPage;
